'use client';
import React from 'react';
var DropdownContext = /*#__PURE__*/React.createContext(null);
DropdownContext.displayName = 'DropdownContext';
export default DropdownContext;